import checks from '@app/application/communication/sections/communication/store/checks'

// InboxChecks reuses communication check module, but exports only some actions
const InboxChecks = {
  state: checks.state,
  getters: checks.getters,
  mutations: checks.mutations,
  actions: {
    addCheckin: checks.actions.addCheckin,
    deleteCheckin: checks.actions.deleteCheckin,
  },
}

export default InboxChecks
